module.exports = __webpack_public_path__ + "static/planbilling-55cefd6b56708ab236529d4648d3e81b.png";